<template>
  <div class="course_ware">
    <div v-if="files.length" class="wrap" >
      <div v-for="v in files" :key="v.id" :class="['file-item', {'locked': v.lockState === 1}]" @click="download(v.type, v.name, v.urlAddress, v.lockState)">
        <VuiIco :class="['ico-left', v.icoClassName]"></VuiIco>
        <p class="name">{{ v.name }}</p>
        <div class="operate">
          <div class="lock_area" v-if="v.lockState === 1">
            <Icon type="md-lock" />
            <span v-if="course.state === COURSE_STATE.LIVING && v.countDown !== 0">{{v.countDown}}</span>
          </div>
          <VuiIco class="ico-right ibang-arrow-right" :w="16"></VuiIco>
        </div>
      </div>
    </div>
    <div v-else class="hint">
      <span class="hint-info">暂时没有课件</span>
    </div>
  </div>
</template>
<script>

import { getIcoClassByFileName } from '@/utils'
import storage from '@/plugins/storage'
import chatBus from '@/bus/chat'
import { COURSE_STATE } from '@/constant/constants'
export default {
  name: 'CourseFiles',
  props: {
    course: {
      type: Object,
    },
  },
  data () {
    return {
      files: [],
      token: storage.get('token'),
      tick: null,
      COURSE_STATE,
    }
  },
  watch: {
    'course.state' (newVal) {
      if (newVal === COURSE_STATE.LIVING) { // 进入关闭状态停止计时
        this.initCountDown()
      }
      if (newVal === COURSE_STATE.ENDED) { // 进入关闭状态停止计时
        this.clearCountDown()
        // 所有文件状态变为可下载
        if (this.files) {
          this.files.forEach(file => {
            file.lockState = 2
          })
        }
      }
    },
  },
  methods: {
    download (type, name, url, lockState) {
      if (lockState === 1) { // 加锁状态
        this.$Message.info(`课件将在开课后${this.course.unlockAttachmentTime}分钟后自动解锁`)
        return
      }
      if (type === 1) { // 如果文件类型是可下载文件
        let domain = process.env.NODE_ENV === 'development' ? this.$config.courseFilesDomain : ''
        let href = `${domain}/live/api/v1/outer/file/seaFile/download/${this.course.pkid || this.course.id}?path=${encodeURIComponent('/')}&fileName=${encodeURIComponent(name)}`
        if (this.token) {
          href += `&school_token=${this.token}`
        }
        if (sessionStorage.getItem('verify-md5')) {
          href += `&verify-md5=${sessionStorage.getItem('verify-md5')}`
        }
        window.location.href = href
      } else if (type === 3) { // 文件类型是链接
        window.open(url, '_blank')
      }
    },
    unlockAttachment (files) {
      if (this.files) {
        this.files.forEach(file => {
          let item = files.find(item => item.attachmentId === file.id)
          if (item) {
            file.lockState = item.lockState
          }
        })
        this.clearCountDown()
      }
    },
    initCountDown () {
      this.clearCountDown()
      this.tick = setInterval(() => {
        this.files.forEach(file => {
          file.countDown = this.caculateCountDown(file)
        })
      }, 1000)
    },
    clearCountDown () {
      this.tick && clearInterval(this.tick)
    },
    caculateCountDown (file) {
      if (file.lockState !== 1) {
        return 0
      }
      const startTime = this.course.startTime
      const unlockAttachmentTime = this.course.unlockAttachmentTime * 60 * 1000
      let times = startTime - Date.now() + unlockAttachmentTime
      if (times <= 0) {
        file.lockState = 0
        return 0
      }
      let hour = Math.floor(times / 3600000)
      let minute = Math.floor((times - hour * 3600000) / 60000)
      let second = Math.floor((times - hour * 3600000 - minute * 60000) / 1000)
      return `${hour >= 10 ? hour : '0' + hour}:${minute >= 10 ? minute : '0' + minute}:${second >= 10 ? second : '0' + second}`
    },
  },
  mounted () {
    this.$store
      .dispatch('course/getCourseFiles', { courseId: this.course.pkid || this.course.id })
      .then(files => {
        this.files = files.map(file => {
          return {
            id: file.id,
            name: file.name,
            type: file.type,
            urlAddress: file.urlAddress,
            lockState: file.lockState,
            icoClassName: getIcoClassByFileName(file.name),
            countDown: this.caculateCountDown(file.lockState),
          }
        })
        if (this.course.state === COURSE_STATE.LIVING) { // 直播状态下倒计时
          this.initCountDown()
        }
      })
    chatBus.$on('unlockattachment', this.unlockAttachment)
  },
  destroyed () {
    chatBus.$off('unlockattachment')
    this.clearCountDown()
  },
}
</script>
<style lang="scss" scoped>
.course_ware {
  height: 100%;
  overflow-y: scroll;
  .wrap{
    position: relative;
    .operate {
      display: flex;
      align-items: center;
    }
    .lock_area {
      display: flex;
      align-items: center;
      padding: 0 8px;
    }
  }

  .file-item {
    min-height: 44px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dfdfdf;
    margin-left: 36px;
    cursor: pointer;
    &:hover {
      color: #ed6c00;
      .ico-right {
        color: #ed6c00;
      }
    }
    &:last-of-type {
      border-bottom: none;
    }
    /deep/ .ivu-icon {
      font-size: 16px;
    }
  }

  .ico-left {
    position: absolute;
    left: -36px;
    top: 50%;
    transform: translateY(-50%);
  }

  .name {
    @include font(14px, 20px);
    white-space: initial;
    padding: 12px 0;
    a {
      color: #000000;
    }
  }

  .ico-right {
    box-sizing: content-box;
    padding: 0 10px;
    color: rgba(0, 0, 0, 0.25);
  }

  .hint {
    text-align: center;
    .hint-info {
      display: block;
      font-size: 14px;
      color: #868686;
      line-height: 60px;
    }
  }
  img {
    display: block;
    margin: 0 auto;
  }
}
</style>
